const productionUrl =
  "https://data-tracking-api-dot-mobs-2019-ncov-web.appspot.com/";

const devUrl =
  "https://data-tracking-api-dev-dot-mobs-2019-ncov-web.appspot.com/";

export { productionUrl, devUrl };
